import comSpSkeleton from "../../../engines/components/comSpSkeleton";
import O1HD from "../../../engines/gameEngine";
import data_control from "../../../engines/libs/data_control";
import NormalGameManager from "../manager/NormalGameManager";

const {ccclass, property} = cc._decorator;

enum animalState{
    Idle,
    Spit,
    Closed
}

@ccclass
export default class animalNode extends cc.Component {

    @property({displayName:"待机动画名字"})
    idleAniName:string = "";

    @property({displayName:"吐舌动画名字"})
    spitAniName:string = "";

    @property({displayName:"吐完动画名字"})
    closeAniName:string = "";

    @property({displayName:"待机动画时间"})
    idleAniTime:number = 0;

    @property({displayName:"吐舌动画时间"})
    spitAniTime:number = 0;

    @property({displayName:"吐完动画时间"})
    closeAniTime:number = 0;

    @property({displayName:"每次点击金币加的金币数量"})
    addCoinCount:number = 0;

    @property({type:comSpSkeleton,displayName:"动物动画"})
    animalAni:comSpSkeleton = null;

    @property({type:cc.Node,displayName:"加金币的文本"})
    addCoin:cc.Node = null;

    @property({displayName:"添加的物品"})
    goodsId:number = 90001;

    state:animalState = animalState.Idle;

    onLoad(){
        this.reviseAni();
    }

    async onClick(){
        if(this.state == animalState.Idle){
            this.state = animalState.Spit;
            await this.reviseAni();
            this.state = animalState.Closed;
            this.reviseAni();
        }
    }

    async onClickGod(){
        if(this.state == animalState.Closed){
            let pos = this.node.convertToWorldSpaceAR( cc.v2());
            O1HD.getManagers().gameMgr.addGoodsEffect( 1 , cc.v2( pos.x+20,pos.y + 60 ) , this.node );
            //添加物品到背包
            NormalGameManager._instance.onPushGoods( this.goodsId ,1 );
            this.state = animalState.Idle;
            this.onClick();
        }
    }

    async reviseAni(){
        return new Promise<void>(resolve=>{
            switch(this.state){
                case animalState.Idle:{
                    this.animalAni.playAnimation(this.idleAniName).start(true);
                    this.scheduleOnce(resolve,this.idleAniTime);
                    break;
                }
                case animalState.Spit:{
                    this.animalAni.playAnimation(this.spitAniName).start(false);
                    this.scheduleOnce(resolve,this.spitAniTime);
                    break;
                }
                case animalState.Closed:{
                    this.animalAni.playAnimation(this.closeAniName).start(true);
                    this.scheduleOnce(resolve,this.closeAniTime);
                    break;
                }
            }
        });
    }

}
